import styles from './states.module.css';

export function LoadingState({ label = 'Cargando…' }: { label?: string }) {
  return (
    <div className={styles.center} role="status" aria-live="polite">
      <div className={styles.spinner} aria-hidden="true" />
      <p className={styles.muted}>{label}</p>
    </div>
  );
}
